import type { IdentifiableU } from '@seddi/core';

export type ArrayDiffPair<T extends IdentifiableU> = {
  next: T;
  prev?: T;
};

export class ArrayDiff {
  // Compare two arrays and returns the diff
  static diff<T extends IdentifiableU>(
    nextArr: Array<T>,
    prevArr: Array<T> | undefined,
  ): [ArrayDiffPair<T>[], T[]] {
    let nextDiff, prevDiff;

    if (!prevArr) {
      nextDiff = nextArr.map((next) => ({ next }));
      prevDiff = <T[]>[];
    } else {
      nextDiff = nextArr.map((next) => ({
        next,
        prev: prevArr.find((prev) => prev._id === next._id),
      }));

      prevDiff = prevArr.filter((prev) => !nextArr.find((next) => prev._id === next._id));
    }

    return [nextDiff, prevDiff];
  }
}
